import React from 'react'
import dateFormat from 'dateformat'
import { Button } from '@sainsburys-tech/bolt'
import getOfferType from '../../helpers/getOfferType'
import autoLinkRender from '../../helpers/autoLinkRender'
import formatDataTest from '../../helpers/formatDataTest'
import ProductImage from '../ProductImage'

import * as Styled from './SpecialOffer.styles'

const SpecialOffer = ({ offer, currentProduct }) => {
  const { attributes, id } = offer
  const { productSets, longDescription, totalFromPrice, endDate } = attributes
  const offerLink = `/product/${currentProduct}/specialoffers/${id}`
  const { textOnlyOffer, isBuilderOffer } = getOfferType(attributes)

  const productSetDetails = (products, host) => ({
    hasMultiSelect: !host && products && products.length > 1,
    mainProductId: products.includes(currentProduct) ? currentProduct : products[0]
  })

  const productSetsDetails = productSets.reduce((list, { products, host, minimumBuyQuantity }) => {
    const originalSetDetails = productSetDetails(products, host)
    const duplicateDetails = productSetDetails(products, false)
    const count = Math.max(0, minimumBuyQuantity - 1)
    return list.concat(originalSetDetails, Array(count).fill(duplicateDetails))
  }, [])

  const buildImage = ({ hasMultiSelect, mainProductId }, key) => (
    <OfferImage {...{ textOnlyOffer, hasMultiSelect, key, mainProductId, offerLink }} />
  )

  const productImages = productSetsDetails.map(buildImage)

  return (
    <Offer>
      <OfferDetails>
        <OfferDescription {...{ longDescription }} />
        {productImages}
      </OfferDetails>
      <OfferSummary {...{ textOnlyOffer, endDate, totalFromPrice, isBuilderOffer, offerLink }} />
    </Offer>
  )
}

const Offer = ({ children }) => <div className='xs-row deal'>{children}</div>
const OfferDetails = ({ children }) => <div className='xs-12--none md-8--none deal__details'>{children}</div>
const OfferDescription = ({ longDescription }) => (
  <p className='xs-12--none' dangerouslySetInnerHTML={{ __html: autoLinkRender(longDescription) }} />
)

const OfferSummary = ({ textOnlyOffer, endDate, totalFromPrice, isBuilderOffer, offerLink }) => {
  if (textOnlyOffer) return null
  const offerEndDate = new Date(endDate).toUTCString()

  const ctaMessage = isBuilderOffer ? 'Build Your Offer' : 'View Offer'
  const dataTest = formatDataTest('special offer', ctaMessage, 'button')
  return (
    <Styled.Container className='xs-12--none md-4--none deal__summary'>
      <Styled.Pricing className='xs-row'>
        <div>From:</div>
        <div>&pound;{totalFromPrice.toFixed(2)}</div>
      </Styled.Pricing>
      <Styled.EndDate>Offer Ends {dateFormat(offerEndDate, 'dS mmmm yyyy', true)}</Styled.EndDate>
      <Styled.LinkButton href={offerLink} rel='nofollow'>
        <Button full data-test={dataTest}>
          {ctaMessage}
        </Button>
      </Styled.LinkButton>
    </Styled.Container>
  )
}

const OfferImage = ({ textOnlyOffer, index, mainProductId, offerLink, hasMultiSelect }) => {
  if (textOnlyOffer) return null

  const chooseItem = <Styled.Placeholder href={offerLink}> choose item </Styled.Placeholder>
  const productImage = <ProductImage partNumber={mainProductId} width={75} height={75} />
  const offerImage = hasMultiSelect ? chooseItem : productImage

  return (
    <Styled.Item key={`product-placeholder-${index}`} data-test='special-offer-item'>
      {offerImage}
    </Styled.Item>
  )
}

export default SpecialOffer
